<template>
  <div class="order-card cursor-pointer" @click="gotoVoucher">
    <div :class="['order-container']">
      <div class="order-image">
        <font-awesome-icon
          :icon="['fa', 'clipboard-list']"
          class="icon-status"
        />
      </div>
      <div class="order-details">
        <div>
          <div class="detail">
            <div class="d-flex">
              <div class=" icon-wrp ">
                {{ con?.custom.voucher }}
              </div>
              <div class="price font-weight-bold text-end">
                {{ con?.custom.percentage }}% {{ $t("off") }}
              </div>
            </div>
          </div>

          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                {{ $t("minimum") }}
              </div>
              <span class="price text-end"> ฿{{ con?.custom.minPrice }} </span>
            </div>
          </div>
          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                {{ $t("maxDiscount") }}
              </div>
              <span class="price text-end">
                ฿{{ con?.custom.discountAmount }}
              </span>
            </div>
          </div>
          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                {{ $t("validUntill") }}
              </div>
              <span class="price text-end">
                {{ con?.custom.endAt | moment($formatDate) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from "moment/moment";
export default {
  name: "ChatOrderCard",
  props: {
    con: {
      required: false,
      type: Object
    }
  },
  methods: {
    handleOpenTab(url) {
      if (url) window.open(decodeURIComponent(url), "_blank");
    },
    moment: function() {
      return moment();
    },
    gotoVoucher() {
      var uri = `https://seller.th.shopee.cn/portal/marketing/vouchers/${this.con?.custom.voucherId}`;
      window.open(uri, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  font-size: 12px;
  margin-bottom: 5px;

  .price {
    color: #832abf;
  }

  .note {
    color: #832abf;
    // cursor: pointer;
  }

  .icon-wrp {
    width: 120px;
  }
}
.order-container {
  display: flex;
  min-height: 40px;
  background-color: #fafafa;
  border-radius: 6px;
  font-size: 14px;

  &.clickable {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .order-image {
    color: #832abf;
    font-size: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
  }

  .order-details {
    flex: 1;
    padding: 5px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .see-detail {
      color: #832abf;
      font-size: 10px;
    }

    .order-status {
      color: #ee4d2d;
      font-size: 10px;
      + div {
        color: #9c9c9c;
      }
    }
  }
}

/* Responsive adjustments */
@media (max-width: 480px) {
}
</style>
